// removed by extract-text-webpack-plugin
module.exports = {"D3Plot":"D3Plot__D3Plot__3wdiv","PlotHeader":"D3Plot__PlotHeader__lI0yU","PlotTitle":"D3Plot__PlotTitle__2WuCk","NavBtns":"D3Plot__NavBtns__2zjhe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/D3Plot/D3Plot.css
// module id = 202
// module chunks = 0